/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考核数据</el-breadcrumb-item>
      <el-breadcrumb-item>商用新商拜访</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
			<el-form-item label="客户名称">
			 <el-input size="small" v-model="formProInfo.name" placeholder="输入客户名称"></el-input>
			</el-form-item>
			
			<el-form-item label="客户类别">
			 <el-select size="small" v-model="formProInfo.customerType" placeholder="请选择">
			    <el-option label="代理商" value="代理商"></el-option>
			    <el-option label="甲方单位" value="甲方单位"></el-option>
			  </el-select>
			</el-form-item>
			
			<el-form-item label="负责人" >
			  <el-input size="small" v-model="formProInfo.linkman" placeholder="输入负责人"></el-input>
			</el-form-item>
			
          <el-form-item label="创建人" >
            <el-input size="small" v-model="formProInfo.creator" placeholder="输入创建人"></el-input>
          </el-form-item>
		  
    	  <el-form-item label="省份">
    	    <el-input size="small" v-model="formProInfo.province" placeholder="输入省份"></el-input>
    	  </el-form-item>
    	  
    	  <el-form-item label="城市">
    	    <el-input size="small" v-model="formProInfo.city" placeholder="输入城市"></el-input>
    	  </el-form-item>
    	  
    	  <el-form-item label="县区">
    	    <el-input size="small" v-model="formProInfo.county" placeholder="输入县区"></el-input>
    	  </el-form-item>
		  
		  <!-- <el-form-item label="状态">
		   <el-select size="small" v-model="formProInfo.status" placeholder="请选择">
		      <el-option label="待举办" value="1"></el-option>
		      <el-option label="已完成" value="2"></el-option>
		    </el-select>
		  </el-form-item> -->
		 
         <!-- <el-form-item label="创建时间">
    	    <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
    	  </el-form-item>
          <el-form-item> -->
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea">重置</el-button>
			<el-button size="small" type="primary" icon="el-icon-search" @click="search" >搜索</el-button>
           
          </el-form-item>
        </el-form>
		<div class="block">
			 <el-radio-group v-model="formProInfo.status" style="margin-bottom: 30px; margin-right: 30px;" @change="changestatus">
				 <el-radio-button label="1" >正常</el-radio-button>
				 <el-radio-button label="2">作废</el-radio-button>
			 </el-radio-group>
		</div>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" prop="name" label="客户名称" >
		  </el-table-column>
		  <el-table-column align="center" prop="linkman" label="负责人" >
		  </el-table-column>
		  <el-table-column align="center" prop="phoneNumber" label="联系方式" >
		  </el-table-column>
		  <el-table-column align="center" prop="customerType" label="客户类别" >
		  </el-table-column>
		  <el-table-column align="center" prop="adrees" label="省市区" >
		  </el-table-column>
		  <el-table-column align="center" prop="creator" label="创建人" >
		  </el-table-column>
		  <el-table-column align="center" prop="createTime" label="创建日期" >
		  </el-table-column>
         
          <el-table-column  align="center"  label="操作" min-width="140">
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">详情</el-button>
			  <el-button size="mini" type="danger" @click="deleteProInfo(scope.row.id)">作废</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		
		
		<el-dialog title="作废" :visible.sync="editFormVisible" width="40%" @close='closeDialog()'>
		  <div class="tipstitle">确认要作废所选订购会么？</div>
		  <div class="tips">操作后无法撤回，请思考一下哟！</div>
		  <el-form label-width="120px" ref="editForm" >
		   
		    <div>
		    
		    <el-form-item   label="作废理由"  >
		      <el-input style="margin-top:10px"
		        type="textarea"
		        :autosize="{ minRows: 4, maxRows: 6}"
		        placeholder="理由"
		        v-model="cancelReason">
		      </el-input>
		    </el-form-item>
		  </div>
		  </el-form>
		
		  
		  <div slot="footer" class="dialog-footer">
		    <el-button size="small" @click='editFormVisible=false' >取消</el-button>
		    <el-button size="small"  @click='delect()' type="danger" :loading="loading">作废</el-button>
		  </div>
		  
		</el-dialog>
		
		
		
		
        
      </div>
    </template>

    <script>
    import {
      queryPageVisitDealerBusiness,
	  cancelVisitDealerBusiness
	  
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          id:'',
		  cancelReason:'',
		  editFormVisible:false,
          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
            //创建人(支持右模糊查询)
            updator: '',
            province:'',
            city:'',
			county:'',
			status:'1',
			customerType:'',
			linkman:''
			
          },
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formProInfo)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  //添加
		  add: function() {
		  	this.$router.push({ path: '/businesscard?shuo=' + '新增'})
		   
		  },
		  //编辑
		  handleEdit: function(row) {
		  	console.log(99999,row)
		  	this.$router.push({ path: '/commercialBusinessVisitadd?id='+row.id + '&shuo=' + '编辑'})
		   
		  },
		  changestatus(e){
			 this.getData(this.formProInfo) 
		  },
		  deleteProInfo(e){
			 this.id = e 
			 this.editFormVisible = true
		  },
		  delect(){
			this.loading = true
			let pageparm = {
				id:this.id,
				cancelReason:this.cancelReason
			}
			cancelVisitDealerBusiness(pageparm).then(res => {
			  console.log(123)
			  this.loading = false
			  if (res.success == false) {
			    this.$message({
			      type: 'info',
			      message: res.msg
			    })
			  } else {
			   this.getData(this.formProInfo)
				this.editFormVisible = false
			  }
			})  
		  },
		  changetype(e){
			  console.log(123456,e)
			  //this.formProInfo.firstLevelId = e
			  let parm = {
					 level:2,
					 category:3,
					 firstLevelId:this.formProInfo.firstLevelId,
					 secondLevelId:''
						 
			  }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.formProInfo.secondLevelId = null
				this.formProInfo.thirdLevelId = null
				this.typeList2 = res.data
				
				}
			  })
		  },
		  
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.province=''
			this.formProInfo.creator=''
			this.formProInfo.city=''
			this.formProInfo.county=''
			this.formProInfo.status=''
		},
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取数据方法
        getData(pageparm) {
          this.loading = true
          queryPageVisitDealerBusiness(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
				  item.adrees = item.province + item.city + item.county
				  
			  })

              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 80px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  .search{
	  position: absolute;
	  right: 0;
	  top: 63px;
  }
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 5px;  
  }
  .refrea{
	  position: absolute;
	  right: 0;
	  top: 0px;
  }
  .user-search{
	  position: relative;
  }
  /deep/ .el-radio-button__inner{
  	  width: 200px;
  }
  /deep/ .el-radio-button__inner{
  	  padding: 8px 20px;
  }
  .block{
  	  display: flex;
  }
  /deep/ .block .el-input__inner{
  	  line-height: 32px;
  	  height: 32px;
  	  border: 0;
  }
  /deep/ .el-input__icon{
  	  font-size: 20px;
  	  height: 36px;
  	  line-height: 32px;
  }
  .tipstitle{
  	  width: 80%;
  	  font-size: 16px;
  	  margin: 0 auto;
  	  margin-bottom: 10px;
  }
  .tips{
  	 width: 80%;
  	 font-size: 12px;
  	 margin: 0 auto;
  	 margin-bottom: 30px;
  }
  /deep/ .el-dialog__body{
  	  padding:10px 20px 30px 30px;
  }
  .el-upload--picture-card{
  	 border: 0 !important; 
  	 background: none;
  }
  /deep/ .el-textarea{
	  width: 300px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/assessment/commercialBusinessVisit.vue